import { setCookie } from '../helpers/cookies';

const DISCLAIMER_COOKIE_NAME = 'DISCLAIMER_ACCEPTED';
const acceptDisclaimer = () => {
  const $cookiesDisclaimer = $('#cookies-disclaimer');
  const disclaimerLifespan = Number($cookiesDisclaimer.data('lifespan')) * 86400000;
  setCookie(DISCLAIMER_COOKIE_NAME, new Date().toISOString(), disclaimerLifespan);
  $('#cookies-disclaimer').addClass('hidden');
};

export const initDisclaimer = () => {
  $('#cookies-disclaimer-accept').on('click', acceptDisclaimer);
};
